import React from 'react';
import { Link } from 'react-router-dom';
//<88181>
const TablaMantenimiento = props => (
  <tbody>
    {
      props.skuvehiculos.length ?
        props.skuvehiculos.map((skuvehiculo,index) => (
          <tr key={index}>
		  	<td>         
            <Link  className="btn btn-blue"
                    role="button"			
                    to={{ pathname: '/mantenimiento-sku-vehiculo/detalle', state: {skuvehiculo} }}>
					Editar</Link>
            </td>
            <td>{skuvehiculo.familia}</td>			
            <td>{skuvehiculo.marca}</td>
			<td>{skuvehiculo.baumuster}</td>
			<td>{skuvehiculo.desConfigVeh}</td>
			<td>{skuvehiculo.skuSap}</td>
			<td>{skuvehiculo.variante}</td>
			<td>{skuvehiculo.tipoVehiculo}</td>
			<td>{skuvehiculo.tipoSku}</td>
			<td>{skuvehiculo.combustible}</td>
           <td>{skuvehiculo.reporteEuro}</td>	
          </tr>
        )) :
        <tr>
          <td colSpan={12}>No hay resultados</td>
        </tr>
    }
  </tbody>
);
export default TablaMantenimiento;
/*

            <Link  className="btn btn-blue"
                    role="button"			
                    to={{ pathname: '/mantenimiento-sku-vehiculo/detalle', state: { from: props.location} }}>
					Editar</Link>
					
 <button className='btn btn-blue' onClick={() => props.openModal('mantenimiento', skuvehiculo)}>Editar</button>
    <Link  className="btn btn-default"
                    role="button"
                    to={{ pathname: '/mantenimiento-sku-vehiculo/detalle'}}>
					<i className="ion-android-add-circle"/>EDITAR</Link>
*/






// WEBPACK FOOTER //
// ./src/pages/MantSkuVehiculo/TablaMantenimiento.js